import { IPost } from 'fitbeat.gym-core';
import React, { FunctionComponent } from 'react';
import { StyleSheet, Text } from 'react-native';
import FastImage from 'react-native-fast-image';
import Theme from '../../theme';
import { LinearGradient } from '../../ui';
import { HorizontalScrollerCard } from './HorizontalScrollerCard';
import { connect } from 'react-redux'
import { dashboardBlogCardPressed } from '../actions';

interface IProps {
  post: IPost;
  showOneWideCard: boolean;
  lastCard: boolean;
  cardPressed: (sourceUri: string) => void;
}

const BlogPostCardComponent: FunctionComponent<IProps> = ({
                                                            post,
                                                            showOneWideCard,
                                                            lastCard,
                                                            cardPressed,
                                                          }) => {
  return (
    <HorizontalScrollerCard
      style={styles.container}
      onPress={() => cardPressed(post)}
      wideCard={showOneWideCard}
      lastCard={lastCard}
    >
      <FastImage
        style={styles.backgroundImage}
        source={{ uri: post.featuredImage }}
        resizeMode={'cover'}
      />
      <Text style={styles.label}>{post.title}</Text>
      <LinearGradient
        colors={['transparent', Theme.BLACK]}
        style={[styles.gradient]}
        webClassName={'summary-dashboard-slider-image-tile'}
      />
    </HorizontalScrollerCard>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  backgroundImage: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    zIndex: 0,
  },
  label: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
    margin: 15,
    textTransform: 'uppercase',
    zIndex: 2,
  },
  gradient: {
    ...StyleSheet.absoluteFill,
    opacity: 0.4,
  },
});

const mapDispatchToProps = (dispatch) => ({
  cardPressed: (blogPost: IPost) => dispatch(dashboardBlogCardPressed(blogPost)),
});

export const BlogPostCard = connect(null, mapDispatchToProps)(BlogPostCardComponent)